import { useQuery } from '@tanstack/react-query';
import {
  getMmmFeatureNames,
  MmmFeatureNameMap
} from '@Pages/GeoMMM/ScenarioPlanning/ScenarioPlanningLambdaUtils';

// Fetches the per-company feature_id -> pretty-name map used to replace opaque MMM feature ids
// in the UI. Keyed by company + modelType (a test company's features resolve to a different real
// proxy per model type, matching the getMmmFeatureNames cache key). Lives at the top level of each
// MMM page type so any tab (Scenario Planning, Model Results, ...) can consume the same map.
export const useFeatureMapping = (
  company: string,
  modelType: string
): ReturnType<typeof useQuery<MmmFeatureNameMap>> =>
  useQuery({
    queryKey: ['mmmFeatureNames', company, modelType],
    queryFn: () => getMmmFeatureNames(company, modelType),
    enabled: Boolean(company)
  });
